export default(storeState, {payload}) => {
  let newState = Object.assign({}, storeState);
  newState.isOpenImageSettingModal = payload.isOpenImageSettingModal
  newState.index = payload.index
  newState.positionChild = payload.positionChild !== undefined ? payload.positionChild : ''
  return newState
};
